<template>
  <ListView
    modelName="PurchaseOrderItem"
    perm="purchase.menu_purchase_order_item"   
    svg="icon_side_order_list" 
    color="steelblue"
    :items.sync="items"
    :params.sync="params"
    title="menu_purchase_order_item"
    :key="$route.fullPath"
    :sortOptions="sortOptions"
    ref="mainList"
    :tabs="['基本情報']"
    gridKey="PurchaseOrderItem"
    :gridCaptions="listCaptions"
    :gridWidths="listWidths"
    :onCreate="onCreate"
    :importQuery="importQuery"
    :exportQuery="exportQuery"
    class="purchase_order_item"
    borderColor="#4099DA"
    backColor="#E5F4FF"    
    tourId="291642"
    :comparer="(a,b)=>a.id == b.id"        
    :popup="popup"    
    :checkStateObject="(a)=>a.order"
  >
    <!-- 明細項目の配置 -->
    <GridItem :slot="listSlots[0]" slot-scope="{ item }"><Badge :value="item.state" list="purchaseOrderItemStatus"/></GridItem>
    <GridItem :slot="listSlots[1]" slot-scope="{ item, index, listView}" :func="true" @click="listView.onOpenDialogByIndex(index)">{{ item.orderItemNo }}</GridItem>
    <GridItem :slot="listSlots[2]" slot-scope="{ item }">{{ item.order.orderDate | date }}</GridItem>
    <GridItem :slot="listSlots[3]" slot-scope="{ item }">{{ item.order.counterpart.name }}</GridItem>
    <GridItem :slot="listSlots[4]" slot-scope="{ item }">{{ item.commodity.name }}</GridItem>
    <GridItem :slot="listSlots[5]" slot-scope="{ item }">{{ item.sku == null ? "" : item.sku.name }}</GridItem>
    <GridItem :slot="listSlots[6]" slot-scope="{ item }">{{ item.uom == null ? item.commodity.uom : item.uom.name }}</GridItem>
    <GridItem :slot="listSlots[7]" slot-scope="{ item }" :right="true">{{ item.quantity | numeric(item.commodity.quantityScale) }}</GridItem>
    <GridItem :slot="listSlots[8]" slot-scope="{ item }">{{ item.answerDeliveryDate | date }}</GridItem>
    <GridItem :slot="listSlots[9]" slot-scope="{ item }">{{ item.scheduledDeliveryDate | date }}</GridItem>
    <GridItem :slot="listSlots[10]" slot-scope="{ item }">{{ item.orderNo }}</GridItem>
    <GridItem :slot="listSlots[11]" slot-scope="{ item }">{{ item.order.currencyCode | currency }}</GridItem>    
    <GridItem :slot="listSlots[12]" slot-scope="{ item }" :right="true">{{ item.unitPrice | numeric }}</GridItem>
    <GridItem :slot="listSlots[13]" slot-scope="{ item }">{{ item.taxCode | taxCode }}</GridItem>
    <GridItem :slot="listSlots[14]" slot-scope="{ item }">{{ item.order.projectItem?item.order.projectItem.name:''}}</GridItem>       
    <GridItem :slot="listSlots[15]" slot-scope="{ item }">{{ item.order.segmentId | segment}}</GridItem>
    <GridItem :slot="listSlots[16]" slot-scope="{ item }">{{ item.order.pic | userGroup }}</GridItem>
    <GridItem :slot="listSlots[17]" slot-scope="{ item }">{{ item.salesOrderItemNo }}</GridItem>

    <GridItem :slot="listSlots[18]" slot-scope="{ item }">{{ item.commodityName }}</GridItem>
    <GridItem :slot="listSlots[19]" slot-scope="{ item }">{{ item.commodity.isNoStock | isNoStock }}</GridItem>
    <GridItem :slot="listSlots[20]" slot-scope="{ item }">{{ item.isNCV | isTarget }}</GridItem>
    <GridItem :slot="listSlots[21]" slot-scope="{ item }" :right="true">{{ item.dealAmountFC | amountFC(item.order.currencyCode)  }}</GridItem>
    <GridItem :slot="listSlots[22]" slot-scope="{ item }" :right="true">{{ item.purchaseDeliveringQuantity | numeric(item.commodity.quantityScale) }}</GridItem>
    <GridItem :slot="listSlots[23]" slot-scope="{ item }" :right="true">{{ item.closedQuantity | numeric(item.commodity.quantityScale) }}</GridItem>
    <GridItem :slot="listSlots[24]" slot-scope="{ item }" :right="true">{{ item.backOrderQuantity | numeric(item.commodity.quantityScale) }}</GridItem>
    <GridItem :slot="listSlots[25]" slot-scope="{ item }" :right="true">{{ item.backPostingQuantity | numeric(item.commodity.quantityScale) }}</GridItem>    
    <GridItem :slot="listSlots[26]" slot-scope="{ item }">{{ item.order.refNo }}</GridItem>
    <!-- <GridItem :slot="listSlots[27]" slot-scope="{ item }">{{ item.salesRefNo }}</GridItem> -->
    <!-- <GridItem :slot="listSlots[28]" slot-scope="{ item }">{{ item.order ? item.order.customerOrderNo : "" }}</GridItem> -->
    
    <GridItem :slot="listSlots[27]" slot-scope="{ item }">{{ item.initialSavedOn | timestamp }}</GridItem>
    <GridItem :slot="listSlots[28]" slot-scope="{ item }">{{ item.initialSavedBy | user }}</GridItem>
    <GridItem :slot="listSlots[29]" slot-scope="{ item }">{{ item.lastUpdatedOn | timestamp }}</GridItem>
    <GridItem :slot="listSlots[30]" slot-scope="{ item }">{{ item.lastUpdatedBy | user  }}</GridItem>

    <!-- 予備項目 -->
    <GridItem :slot="listSlots[31]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveText1 == usedTypes.CommodityMemo ? item.commodity.reserveText1 : item.reserveText1)}}</GridItem>
    <GridItem :slot="listSlots[32]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveText2 == usedTypes.CommodityMemo ? item.commodity.reserveText2 : item.reserveText2)}}</GridItem>
    <GridItem :slot="listSlots[33]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveText3 == usedTypes.CommodityMemo ? item.commodity.reserveText3 : item.reserveText3)}}</GridItem>
    <GridItem :slot="listSlots[34]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveText4 == usedTypes.CommodityMemo ? item.commodity.reserveText4 : item.reserveText4)}}</GridItem>
    <GridItem :slot="listSlots[35]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveText5 == usedTypes.CommodityMemo ? item.commodity.reserveText5 : item.reserveText5)}}</GridItem>
    <GridItem :slot="listSlots[36]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveText6 == usedTypes.CommodityMemo ? item.commodity.reserveText6 : item.reserveText6)}}</GridItem>
    <GridItem :slot="listSlots[37]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveMemo1 == usedTypes.CommodityMemo ? item.commodity.reserveMemo1 : item.reserveMemo1)}}</GridItem>
    <GridItem :slot="listSlots[38]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveMemo2 == usedTypes.CommodityMemo ? item.commodity.reserveMemo2 : item.reserveMemo2)}}</GridItem>
    <GridItem :slot="listSlots[39]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveMemo3 == usedTypes.CommodityMemo ? item.commodity.reserveMemo3 : item.reserveMemo3)}}</GridItem>
    <GridItem :slot="listSlots[40]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveDate1 == usedTypes.CommodityMemo ? item.commodity.reserveDate1 : item.reserveDate1) | date}}</GridItem>
    <GridItem :slot="listSlots[41]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveDate2 == usedTypes.CommodityMemo ? item.commodity.reserveDate2 : item.reserveDate2) | date}}</GridItem>
    <GridItem :slot="listSlots[42]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveDate3 == usedTypes.CommodityMemo ? item.commodity.reserveDate3 : item.reserveDate3)| date}}</GridItem>
    <GridItem :slot="listSlots[43]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveList1 == usedTypes.CommodityMemo ? item.commodity.reserveList1 : item.reserveList1 ) | category_41}}</GridItem>
    <GridItem :slot="listSlots[44]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveList2 == usedTypes.CommodityMemo ? item.commodity.reserveList2 : item.reserveList2 ) | category_42}}</GridItem>
    <GridItem :slot="listSlots[45]" slot-scope="{ item }" >{{(tenantSettings.usedTypeDetailReserveList3 == usedTypes.CommodityMemo ? item.commodity.reserveList3 : item.reserveList3 ) | category_43}}</GridItem>    

    <!-- リストメニューの配置 -->
    <div slot="menu" slot-scope="{ listView }">
      <ListViewMenuBar :listView="listView" :add="false" :copy="false">
        <ListViewMenu title="納期更新" @click="showUpdateDeliveryDateDialog" tooltip="【回答納期】と【入荷予定日】を一括で更新する事ができます。"/>
        <ListViewMenu title="入荷処理" @click="showCreatePurchaseDeliveryDialog(false)" tooltip="発注した商品が倉庫に入荷した際に行う処理です。【納入区分】が直送の場合､入荷処理を行うと同時に出荷データが作成されます。"/>
        <ListViewMenu title="未着品処理" @click="showCreatePurchaseDeliveryDialog(true)" tooltip="発注した商品が実際に倉庫や出荷先に届く前に仕訳を発生させる処理です。尚､同時に数量も在庫データに反映され､直送の場合は出荷データが作成されます。"/>        
      </ListViewMenuBar>
    </div>
    <!-- 検索パネルーの配置 -->
    <template slot="search" slot-scope="{ params, handler, listView }">
      <Search :listView="listView" :tabs="searchTabs">
        <FilterBox title="発注番号" :value.sync="params.orderNo" @click="handler" />
        <FilterBox title="発注明細番号" :value.sync="params.orderItemNo" @click="handler" />
        <FilterBox title="発注管理番号" :value.sync="params.refNo" @click="handler" />
        <FilterBox title="受注明細番号" :value.sync="params.salesOrderItemNo" @click="handler" />
        <FilterBox title="商品名称" :value.sync="params.commodityName" @click="handler" />
        <FilterBox title="備考" :value.sync="params.description" @click="handler" />

        <!-- <FilterBox title="顧客注文番号" :value.sync="params.customerOrderNo" @click="handler" /> -->
        <AtcCounterpart title="仕入先" :value.sync="params.counterpart" :needsSupplier="true" @changed="handler" />
        <AtcSegment title="部門" :value.sync="params.segment" @changed="handler" />
        <AutoComplete title="担当者" :value.sync="params.pic" list="user" @changed="handler" />
        <AutoComplete title="取引通貨"  :value.sync="params.currencyCode" list="currency" @changed="handler" v-if="hasLicenseCurrency" />              
        <AtcCommodity title="商品" :value.sync="params.commodity" @changed="handler" />
        <AtcSKU title="SKU" :value.sync="params.sku" :commodity="params.commodity" @update:value="handler" />                

        <Calendar title="発注日(From)" :value.sync="params.orderDateFrom" :deletable="true" @changed="handler" />
        <Calendar title="発注日(To)" :value.sync="params.orderDateTo" :deletable="true" @changed="handler" />
        <Calendar title="回答納期(From)" :value.sync="params.answerDeliveryDateFrom" :deletable="true" @changed="handler" />
        <Calendar title="回答納期(To)" :value.sync="params.answerDeliveryDateTo" :deletable="true" @changed="handler" />
        <Calendar title="入荷予定日(From)" :value.sync="params.scheduledDeliveryDateFrom" :deletable="true" @changed="handler" />
        <Calendar title="入荷予定日(To)" :value.sync="params.scheduledDeliveryDateTo" :deletable="true" @changed="handler" />
        <Calendar title="初回保存日(From)" :value.sync="params.initialSavedOnFrom" :deletable="true" @changed="handler" />
        <Calendar title="初回保存日(To)" :value.sync="params.initialSavedOnTo" :deletable="true" @changed="handler" />
        <Calendar title="最終更新日(From)" :value.sync="params.lastUpdatedOnFrom" :deletable="true" @changed="handler" />
        <Calendar title="最終更新日(To)" :value.sync="params.lastUpdatedOnTo" :deletable="true" @changed="handler" />
        <AutoComplete title="所有者" :value.sync="params.holder" list="user" @changed="handler" />                 
        <ComboBox title="状態" :value.sync="params.state" :list="hasLicenseCurrency ? 'purchaseOrderStatus' : 'purchaseOrderStatusNoLicenseCurrency'" @changed="handler" />
        <!-- <ComboBox title="所有者" :value.sync="params.holder" list="user" @changed="handler" /> -->

        <FilterBox slot="tab1" title="reserve_text1" :value.sync="params.reserveText1" @click="handler"   v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveText1)" />
        <FilterBox slot="tab1" title="reserve_text2" :value.sync="params.reserveText2" @click="handler"  v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveText2)"/>
        <FilterBox slot="tab1" title="reserve_text3" :value.sync="params.reserveText3" @click="handler"  v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveText3)"/>
        <FilterBox slot="tab1" title="reserve_text4" :value.sync="params.reserveText4" @click="handler"  v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveText4)"/>
        <FilterBox slot="tab1" title="reserve_text5" :value.sync="params.reserveText5" @click="handler"  v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveText5)"/>
        <FilterBox slot="tab1" title="reserve_text6" :value.sync="params.reserveText6" @click="handler"  v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveText6)"/>
        <FilterBox slot="tab1" title="reserve_memo1" :value.sync="params.reserveMemo1" @click="handler" v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveMemo1)"/>
        <FilterBox slot="tab1" title="reserve_memo2" :value.sync="params.reserveMemo2" @click="handler" v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveMemo2)"/>
        <FilterBox slot="tab1" title="reserve_memo3" :value.sync="params.reserveMemo3" @click="handler" v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveMemo3)"/>
        <Calendar slot="tab1" title="reserve_date1|(From)" :value.sync="params.reserveDate1From" :deletable="true" @changed="handler" v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveDate1)"/>
        <Calendar slot="tab1" title="reserve_date1|(To)" :value.sync="params.reserveDate1To" :deletable="true" @changed="handler" v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveDate1)"/>
        <Calendar slot="tab1" title="reserve_date2|(From)" :value.sync="params.reserveDate2From" :deletable="true" @changed="handler" v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveDate2)"/>
        <Calendar slot="tab1" title="reserve_date2|(To)" :value.sync="params.reserveDate2To" :deletable="true" @changed="handler" v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveDate2)"/>
        <Calendar slot="tab1" title="reserve_date3|(From)" :value.sync="params.reserveDate3From" :deletable="true" @changed="handler" v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveDate3)"/>
        <Calendar slot="tab1" title="reserve_date3|(To)" :value.sync="params.reserveDate3To" :deletable="true" @changed="handler" v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveDate3)"/>
        <ComboBox slot="tab1" title="reserve_list1" :value.sync="params.reserveList1" list="category_41" @changed="handler"  v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveList1)"/>
        <ComboBox slot="tab1" title="reserve_list2" :value.sync="params.reserveList2" list="category_42" @changed="handler"  v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveList2)"/>
        <ComboBox slot="tab1" title="reserve_list3" :value.sync="params.reserveList3" list="category_43" @changed="handler"  v-if="isSearchVisible(tenantSettings.usedTypeDetailReserveList3)"/>                

      </Search>
    </template>
    <!-- フルサイズエディタの配置(ListView:fullSizeEditor="true"を指定) -->
    <template slot="sideEditor" slot-scope="{ listView }">
      <Editor :item="listView.selected" :owner="listView" :tabs="['基本情報','入荷明細','その他情報','納入先詳細','予備項目','更新履歴']" :tabVisibles="tabVisibles" :tabTooltips="[null,'選択した発注明細に紐づいている入荷明細を表示します。',null,'【納入先】の情報が表示されます。【発注明細一覧】からは変更できません。','商品単位で任意にテキスト入力・区分の設定・日付設定を行えます｡項目名は【テナント設定】＞【商品予備項目】から変更が可能です。',null]">
        <!-- エディタ編集・機能ボタン -->
        <template slot="menu" slot-scope="{ item}">
          <!-- <Button class="button" @click="showPurchaseOrder" caption="伝票表示" :disabled="editor.isEdit" icon="arrow_upward"/> -->
          <SplitButton class="button" @click="showDirectAccessDialg(item)" caption="関連伝票"  icon="account_tree" tooltip="関連する伝票へのリンクを表示します。">            
            <Button class="button" @click="showPurchaseDeliveryItem" caption="入荷明細表示" :disabled="disabledShowPurchaseDeliveryItemButton(item)" icon="arrow_forward" tooltip="選択した発注に紐づいている【入荷明細】の一覧を表示します。"/>
          </SplitButton>
        </template>
        <!-- 基本情報タブ -->
        <template slot="tab0" slot-scope="{ item, editor }">
          <EditPanel>
            <!-- 基本情報タブ 左側 -->
            <template slot="left">
              <RowSequence title="明細番号" :value="item.seqNo" :displayValue="item.orderItemNo"  :perm="$refs.mainList.perm+'.edit'"   :item="item" :editor="editor" :enabled="isEditable(item.state)" tooltip="【発注番号】に紐づく明細番号が初回保存時に自動で付与されます。" buttonTooltip="1件の発注に複数の発注明細が登録されている場合､明細の順番を変更する事ができます。明細の数が１つしかない場合は変更できません。"/>
              <!-- <TextBox title="明細番号" :value="item.orderItemNo" :editor="editor" :enabled="false" /> -->
              <TextBox title="発注日" :value="$api.formatter.formatDate(item.order != null ? item.order.orderDate : null)" :enabled="false" tooltip="発注一覧で登録した発注日が表示されます。【発注明細一覧】からは変更できません。"/>              
              <AtcCounterpart title="仕入先" :value="item.order != null ? item.order.counterpart : null" :editor="editor" :needsCustomer="true" :enabled="false" tooltip="発注一覧で登録した【仕入先】が表示されます。【発注明細一覧】からは変更できません。"/>
              <AtcCommodity title="商品" :value.sync="item.commodity" :editor="editor" :required="true" :enabled="isEditableNoTakeOverSales(item.state,item)" @update:value="onChangeCommodity(item)" tooltip="発注する商品です。【商品一覧】の確定されているデータから選択できます。"/>
              <AtcSKU title="SKU" :value.sync="item.sku" :editor="editor" :commodity="item.commodity" :enabled="isEditableNoTakeOverSales(item.state,item)" tooltip="【商品】に対応したSKUを選択できます。【SKU一覧】より商品にSKUを設定している場合に、選択が可能です。"/>
              <!-- <AtcConversion title="単位" :value.sync="item.uom2" :editor="editor" :required="true" :enabled="isEditable(item.state)" :commodity="item.commodity" tooltip="【商品】に対応した単位が表示されます。【商品一覧】に登録されている【計上単位】､または【荷姿一覧】に登録した単位が表示されます。"/> -->
              <div style="display:flex;justify-content:space-between;">
                <AtcConversion title="単位" :value.sync="item.uom2" :editor="editor" :required="true" :enabled="isEditable(item.state)" :commodity="item.commodity" tooltip="【商品】に対応した単位が表示されます。【商品一覧】に登録されている【計上単位】､または【荷姿一覧】に登録した単位が表示されます。"/>
                <BtnStockSchedule v-if="$api.useStockFunction" :commodity="item.commodity" :sku="item.sku" :stockDate="item.scheduledDeliveryDate" :segment="item.order.segment"/>
              </div>              
              <NumericBox title="発注数量" :value.sync="item.quantity" :editor="editor" :required="true" :enabled="isEditable(item.state)" :decimals="item.commodity == null ? 0 : item.commodity.quantityScale" :min="(item.commodity && item.commodity.isNoStock) ? -99999999.999 :0" :max="99999999.999" :nullValue="0" />
              <TextBox title="取引通貨" :value="item.order.currencyCode| currency"  :enabled="false" v-if="hasLicenseCurrency"/>
              <div style="display:flex">
                <NumericBox title="単価" :value.sync="item.unitPrice" :editor="editor" :required="false" :enabled="isEditable(item.state)" :decimals="item.commodity == null ? 0 : item.commodity.stockPriceScale" :min="-999999999.999999" :max="999999999.999999" :nullValue="0" />
                <Button class="button cx_itembutton" style="margin-left:10px"  @click="getPriceAndTaxCode(item)" caption="単価取得" :disabled="!editor.isEdit || !isEditable(item.state)" tooltip="商品の単価を取得します。単価の取得基準は【商品一覧】の【販売単価区分】で登録をします。"/>
              </div>              
              <AtcTaxCode title="税区分" :value.sync="item.taxCode" :editor="editor" list="taxCode" :required="true" :enabled="isEditable(item.state)" tooltip="登録する税区分を選択します。【税区分一覧】のデータを選択できます。"/>            
            </template>
            <!-- 基本情報タブ 右側 -->
            <template slot="right">
              <TextBox title="発注番号" :value="item.orderNo" :editor="editor" :enabled="false" linkFormat="/purchase/PurchaseOrder?orderNo={0}" tooltip="選択した発注明細に対応する発注番号が表示されています。クリックすることで発注一覧に移動します。"/>
              <Calendar title="希望納期" :value.sync="item.itemRequestDate" :editor="editor" :deletable="true" :enabled="isEditable(item.state)" tooltip="商品の到着希望日を入力します。初期値は発注伝票の【希望納期】が設定されます。"/>
              <Calendar title="回答納期" :value.sync="item.answerDeliveryDate" :editor="editor" :deletable="true" :enabled="isEditable(item.state)" tooltip="仕入先から回答された納期を入力します。希望する商品到着日である【希望納期】とは異なります。"/>
              <Calendar title="入荷予定日" :value.sync="item.scheduledDeliveryDate" :editor="editor" :deletable="true" :enabled="isEditable(item.state)" tooltip="商品が実際に倉庫または出荷先に到着する予定日を入力します｡"/>              
              <AtcSegment title="部門" :value.sync="item.order.segment" :enabled="false" tooltip="担当部門を選択します。【部門一覧】のデータから選択することができます。"/>
              <AutoComplete title="担当者" :value.sync="item.order.pic"  list="user"  :enabled="false" tooltip="案件を担当する人を選択します。【ユーザー】のデータを選択することができます。"/>
              <TextBox title="受注明細番号" :value="item.salesOrderItemNo" :editor="editor" :enabled="false" linkFormat="/sales/SalesOrderItem?orderItemNo={0}"  tooltip="発注明細伝票に対応する受注明細番号が表示されます。"/>              
              <TextBox title="最終更新日" :value="$api.perms.getLastUpdateLabel(item)" :enabled="false" tooltip="発注データを最後に更新した日時が表示されています。"/>              
              <TextBox title="状態" :value="$api.perms.getStateLabel(item,'purchaseOrderItemStatus')" :enabled="false" tooltip="発注明細データの現在の状態が表示されており､業務処理や発注一覧で確定を行う事で変化します。"/>       
            </template>
          </EditPanel>
        </template>
        <!-- 入荷明細タブ -->
        <template slot="tab1" slot-scope="{ item}">
          <GrdVoucherItem :voucherNo="item.orderItemNo" :voucherType="voucherTypes.PurchaseOrderItem" :voucherItemType="voucherTypes.PurchaseDeliveryItem" ref="purchaseDeliveryItems" />
        </template>          
        <!-- その他情報タブ -->
        <template slot="tab2" slot-scope="{ item,editor}">
          <EditPanel>
            <!-- その他情報タブ 左側 -->
            <template slot="left">
              <TextBox title="商品名称" :value.sync="item.commodityName" :editor="editor" :required="true" :enabled="isEditable(item.state)" :length="100" tooltip="初期値は【商品一覧】の【名称】の値になっていますが､任意で変更する事が可能です。"/>
              <TextBox title="棚卸対象外" :value="(item.commodity != null ? item.commodity.isNoStock : false) | isNoStock" :editor="editor" :enabled="false" tooltip="【商品】に登録した商品の【棚卸商品区分】の値が表示されます。"/>              
              <CheckBox title="NCV" :value.sync="item.isNCV" :editor="editor" list="isTarget" :enabled="isEditable(item.state)" v-if="hasLicenseCurrency" />
              <TextBox title="取引金額" :value="$api.formatter.formatAmountFC(item.dealAmountFC,item.order.currencyCode)" :enabled="false"  :nullValue="0" tooltip="取引金額が表示されます。【発注数量×単価】の計算方法で出力されています。"/>              
              <NumericBox title="入荷済み数量" :value.sync="item.purchaseDeliveringQuantity" :editor="editor" :enabled="false"  :nullValue="0" :decimals="item.commodity == null ? 0 : item.commodity.quantityScale" tooltip="発注数量に対して入荷処理されている数量が表示されています。"/>
              <NumericBox title="クローズ数量" :value.sync="item.closedQuantity" :editor="editor" :enabled="(item.quantity - item.purchaseDeliveringQuantity!=0 || item.closedQuantity!=0) && !isEditable(item.state)"  :nullValue="0" :decimals="item.commodity == null ? 0 : item.commodity.quantityScale"  :min="0" :max="item.quantity - item.purchaseDeliveringQuantity" tooltip="発注数量に対してクローズ（終了）とされた数量です。発注残がある場合、任意で変更することが可能です。"/>
              <NumericBox title="発注残数量" :value="item.backOrderQuantity" :editor="editor" :enabled="false" :decimals="item.commodity == null ? 0 : item.commodity.quantityScale" tooltip="発注数量から入荷、クローズされた数量を引いた数値が表示されます。【発注数量－入荷数量(保存)－発注クローズ数量＝発注残数量】"/>
            </template>
            <!-- その他情報タブ 右側 -->
            <template slot="right">
              <TextBox title="発注管理番号" :value.sync="item.order.refNo" :enabled="false" tooltip="発注一覧で登録した【発注管理番号】が表示されます。【発注明細一覧】の【編集】ボタンからは変更できません。"/>
              <TextBox title="受注顧客注文番号" :value.sync="item.salesCustomerOrderNo" :enabled="false" tooltip="受注一覧で登録した【顧客注文番号】が表示されます。【発注明細一覧】の【編集】ボタンからは変更できません。"/>
              <TextBox title="備考" :value.sync="item.description" :editor="editor" :enabled="isEditable(item.state)" :length="200" :rows="10"  tooltip="任意で発注明細に関わる様々な情報を最大200文字まで入力することができます。"/>              
            </template>
          </EditPanel>
        </template> 
        <!-- 納入先詳細タブ -->
        <template slot="tab3" slot-scope="{ item, editor }">
          <EditPanel>
            <!-- 納入先詳細タブ 左側 -->
            <template slot="left">
              <TextBox title="納入先名称" :editor="editor" :value.sync="item.order.outputReceiverName" :enabled="false" length="50" />
              <TextBox title="担当部署名" :editor="editor" :value.sync="item.order.outputReceiverPICSection" :enabled="false" length="50" />
              <TextBox title="担当者" :editor="editor" :value.sync="item.order.outputReceiverPIC" :enabled="false" length="30" />
              <TextBox title="敬称" :editor="editor" :value.sync="item.order.outputReceiverPICHonorificTitle" :enabled="false" length="5" />
              <TextBox title="電話番号" :editor="editor" :value.sync="item.order.outputReceiverTelNo" :enabled="false" length="20" />
              <TextBox title="FAX番号" :editor="editor" :value.sync="item.order.outputReceiverFaxNo" :enabled="false" length="20" />
            </template>
            <!-- 納入先詳細タブ 右側 -->
            <template slot="right">
              <TextBox title="郵便番号" :editor="editor" :value.sync="item.order.outputReceiverPostalCode" :enabled="false" length="50" />
              <TextBox title="住所1" :editor="editor" :value.sync="item.order.outputReceiverAddress1" :enabled="false" length="50" />
              <TextBox title="住所2" :editor="editor" :value.sync="item.order.outputReceiverAddress2" :enabled="false" length="50" />
              <TextBox title="住所3" :editor="editor" :value.sync="item.order.outputReceiverAddress3" :enabled="false" length="50" />
            </template>
          </EditPanel>
        </template>                                           
        <!-- 予備項目タブ -->
        <template slot="tab4" slot-scope="{ item, editor }">
          <PnlReserveItems :item="item" :editor="editor" :enabled="isEditable(item.state)" :commodityAttribute="visibleTypes.Editable"  :orderMemo="visibleTypes.Editable" :inheritCommodityAttributeInvalid="true" :commodity="item.commodity" />          
        </template>
        <!-- 更新履歴タブ -->
        <template slot="tab5" slot-scope="{ item }">
          <AuditLog :auditName="item.auditName" :auditNo="item.auditNo" />
        </template>
      </Editor>
    </template>
    <template slot="modal" slot-scope="{ listView }">        
      <!-- 納期更新ダイアログ -->
      <ListDialog ref="updateDeliveryDateDialog" title="納期更新" :captions="[]" :widths="[]" :showAdd="false" :showRemove="false" :exec="submitUpdateDeliveryDate" >
        <template slot="header">
          <Calendar title="回答納期" :value.sync="uddAnswerDeliveryDate" :deletable="true" tooltip="回答納期に変更があった場合変更された日付を入力します。"/>
          <Calendar title="入荷予定日" :value.sync="uddScheduledDeliveryDate" :deletable="true" tooltip="入荷予定日に変更があった場合変更された日付を入力します。"/>
        </template>
      </ListDialog>
      
    </template>
  </ListView>
</template>

<script lang="ts">
import { Component, Vue, Prop } from 'vue-property-decorator';
import * as Common from '@/tenant/common';
import * as Components from '@/tenant/components';

@Component
export default class PurchaseOrderItemView extends Vue {
  public createPurchaseDelivery = Components.CreatePurchaseDelivery;
  public items: Common.PurchaseOrderItem[] = new Array(0);
  public params: Common.OrderItemQuery = new Common.OrderItemQuery(Common.SalesPurchaseFlags.Purchase);
  public importQuery = new Common.OrderItemImportQuery('発注明細',Common.SalesPurchaseFlags.Purchase);
  public exportQuery = new Common.OrderItemExportQuery('発注明細', this.params,Common.SalesPurchaseFlags.Purchase);
  public usedTypes = Common.UsedTypes;  
  public sortOptions: any = [
    { value: 'State', text: '状態' },
    { value: 'orderItemNo', text: '明細番号' },
    { value: 'orderDate', text: '発注日' },
    { value: 'counterpart', text: '仕入先' },
    { value: 'commodity', text: '商品' },
    { value: 'answerDeliveryDate', text: '回答納期' },
    { value: 'scheduledDeliveryDate', text: '入荷予定日' },
    { value: 'orderNo', text: '発注番号' },
    { value: 'segment', text: '部門' },
    { value: 'pic', text: '担当者' },
    { value: 'salesOrderItemNo', text: '受注明細番号' },
    { value: 'commodityName', text: '商品名称' },
    { value: 'refNo', text: '発注管理番号' },
    { value: 'initialSavedOn', text: '初回保存日' },
    { value: 'initialSavedBy', text: '初回保存者' },
    { value: 'lastUpdatedOn', text: '最終更新日' },
    { value: 'lastUpdatedBy', text: '最終更新者' },
  ];
  public tabVisibles: Array<boolean> = [true, true, true, true, true, true, true];
  public tenantSettings: Common.TenantSettings = null;
  public voucherTypes = Common.voucherTypes;
  public visibleTypes = Common.visibleTypes;
    
  @Prop() public orderNo:string;
  @Prop() public orderItemNo:string;
  @Prop() public salesOrderItemNo:string;
  @Prop() public commodity:Common.Commodity;
  @Prop() public sku:Common.SKU;  
  @Prop() public state:Common.OrderItemStatus;    
  @Prop() public scheduledDeliveryDateTo: Date;
  @Prop({default:null}) public popup: Components.PopupEditor; 
  
  public hasLicenseCurrency: boolean = false;
  // 一覧可変表示用プロパティ
  public listCaptions = new Array();
  public listWidths = new Array();
  public listSlots = new Array();
  public gridConfig:Common.GridConfiguration = new Common.GridConfiguration([],0, 'grid');

  public created() {
    //テナント設定をロードする
    // this.$api.execute(new Common.TenantSettingsLoadQuery()).then(res => (this.tenantSettings = res));
    this.tenantSettings = this.$api.tenantSettings;    

    // ライセンスによって表示項目を制御する
    this.hasLicenseCurrency = this.$api.hasLicense(Common.licenseFlags.currency);

    // タブ表示の制御
    this.$set(this.tabVisibles, 4, this.$api.useStockFunction); // 予備項目タブ

    //'状態', '発注番号', '行番号', '明細番号', '受注明細番号', '発注日', '部門', '仕入先', '担当者', '商品',
    // '商品名称', '棚卸対象外', '単位', 'SKU', '発注数量', '単価', '税区分', 'NCV', '取引金額',  '備考',
    // '回答納期', '入荷予定日', '発注残数量','発注残数量(計上単位)', 'クローズ数量', '発注管理番号', '受注管理番号', '顧客注文番号', 'ワークフロー', '初回保存日',
    // '初回保存者', '最終更新日', '最終更新者'
    // 一覧表示項目の制御
    this.gridConfig.setGridItems(
      new Common.GridItemConfiguration('状態', 170),
      new Common.GridItemConfiguration('明細番号', 150),
      new Common.GridItemConfiguration('発注日', 120),
      new Common.GridItemConfiguration('仕入先', 180),
      new Common.GridItemConfiguration('商品', 150),
      new Common.GridItemConfiguration('SKU', 150),              
      new Common.GridItemConfiguration('単位', 100),
      new Common.GridItemConfiguration('発注数量', 120),
      new Common.GridItemConfiguration('回答納期', 120),
      new Common.GridItemConfiguration('入荷予定日', 120),              
      new Common.GridItemConfiguration('発注番号', 120),
      new Common.GridItemConfiguration('取引通貨', 120,this.hasLicenseCurrency),
      new Common.GridItemConfiguration('単価', 120),
      new Common.GridItemConfiguration('税区分', 120),
      new Common.GridItemConfiguration('案件', 150),      
      new Common.GridItemConfiguration('部門', 150),
      new Common.GridItemConfiguration('担当者', 150),                              
      new Common.GridItemConfiguration('受注明細番号', 150),

      new Common.GridItemConfiguration('商品名称', 150),
      new Common.GridItemConfiguration('棚卸対象外', 150),
      new Common.GridItemConfiguration('NCV', 150,this.hasLicenseCurrency),            
      new Common.GridItemConfiguration('取引金額', 150),
      new Common.GridItemConfiguration('入荷済み数量', 150),
      new Common.GridItemConfiguration('クローズ数量', 150),      
      new Common.GridItemConfiguration('発注残数量', 150),
      new Common.GridItemConfiguration('発注残数量(計上単位)', 150),
      new Common.GridItemConfiguration('発注管理番号', 150),
      // new Common.GridItemConfiguration('受注管理番号', 150),
      // new Common.GridItemConfiguration('顧客注文番号', 150),            

      new Common.GridItemConfiguration('初回保存日', 150),
      new Common.GridItemConfiguration('初回保存者', 150),
      new Common.GridItemConfiguration('最終更新日', 150),
      new Common.GridItemConfiguration('最終更新者', 150),          
    );
    this.gridConfig.setGridItems(...this.tenantSettings.GetGridItems(true,false,true,true,false));
    this.listCaptions = this.gridConfig.gridCaptions;
    this.listWidths = this.gridConfig.gridWidths;
    this.listSlots = this.gridConfig.gridSlots;
    this.exportQuery.hasLicenseCurrency = this.hasLicenseCurrency;

    // 検索条件を設定する
    if(this.orderNo){
      this.params.orderNo = this.orderNo;
      this.params.state = null;
    }
    else if(this.salesOrderItemNo){
      this.params.salesOrderItemNo = this.salesOrderItemNo;
      this.params.state = null;
    }
    else if(this.orderItemNo){
      this.params.orderItemNo = this.orderItemNo;
      this.params.state = null;
    }else if (!this.commodity && !this.sku && !this.state && !this.scheduledDeliveryDateTo){
      this.params.holder = this.$api.license.countOnlyOwned ? this.$api.auth.userId : "";
		}    
    //タスク表示モードの設定(全件/未完了)
    if (this.$api.onlyOpen == false) this.params.state = null;
            
    if (this.commodity)this.params.commodity = this.commodity;
    if (this.sku)this.params.sku = this.sku;
    if (this.state)this.params.state = this.state;   
    if (this.scheduledDeliveryDateTo)this.params.scheduledDeliveryDateTo = this.scheduledDeliveryDateTo;        
    
    // 子画面用ワークフロー情報をロードする
    this.$api.formatter.ensureListLoaded('workflow_purchaseDelivery');
    this.$api.formatter.ensureListLoaded('workflow_purchaseInvoice');
  }
 
  public async onCreate(obj: Common.PurchaseOrderItem) {
    // const workflows = this.$api.formatter.getOptions('workflow_purchaseOrderItem');
    // if (workflows.length > 0) obj.workflowId = workflows[0].value;
    return Promise.resolve(obj);
  }

  public onWorkflow(index: number, obj: any) {
    this.$set(this.items, index, obj);
  }

  // 商品変更時に商品名・予備項目を設定する
  public onChangeCommodity(item:Common.PurchaseOrderItem){
    item.onChangeCommodity(this.tenantSettings);
  }

  // 単価・税区分を取得する
  public getPriceAndTaxCode(item:Common.PurchaseOrderItem){
    this.$api.execute(new Common.OrderGetItemPriceQuery(item.order, item)).then(res => {
      item.unitPrice = res.unitPrice;
      item.taxCode = res.taxCode;
    });
  }

  // 状態から編集可能か判別する
  public isEditable(state: Common.OrderItemStatus):boolean{
    if(state == Common.OrderItemStatus.PurchaseOrderSaving) return true;
    return false;
  }

  // 保存状態、且つ受注非継承時に編集可
  public isEditableNoTakeOverSales(state: Common.OrderItemStatus, item: Common.OrderItem):boolean{
    if(!this.isEditable(state)) return false;
    if(item.salesOrderItemNo) return false;
    return true;
  }

  // 一覧でチェックされている発注明細
  public checkedOrderItems: Array<Common.OrderItem>= new Array(0);
  public getCheckedOrderItems(){
    this.checkedOrderItems = new Array(0);
    const view = this.$refs.mainList as Components.ListView;
    this.items.forEach((obj, index) => {
      if ((view.$refs.listBox as Components.Grid).checked[index]) {
        obj.deliveringQuantity = 0;
        this.checkedOrderItems.push(obj);
      }
    });
  }

  // 納期更新用プロパティ
  public uddAnswerDeliveryDate:Date = new Date().getCalendarDate();
  public uddScheduledDeliveryDate:Date = new Date().getCalendarDate();

  // 納期更新ダイアログの表示
  public showUpdateDeliveryDateDialog() {
    this.getCheckedOrderItems();

    // ダイアログ表示前バリデーション
    if(this.checkedOrderItems.length == 0){
      this.$api.modal.show('', '対象の明細を選択して下さい。', true, null);
      return;
    }

    // プロパティの初期化
    this.uddAnswerDeliveryDate = null;//new Date().getCalendarDate();
    this.uddScheduledDeliveryDate = null;//new Date().getCalendarDate();

    // ダイアログを表示
    (this.$refs.updateDeliveryDateDialog as Components.ListDialog).showDialog();
  }

  // 画面のリフレッシュ(再描画)
  public refreshListView(){
    var page = (this.$refs.mainList as Components.ListView).currentPage;
    (this.$refs.mainList as Components.ListView).onPageChange(page);
  }

  // 納期更新の実行
  public async submitUpdateDeliveryDate() {
    var query = new Common.UpdateDeliveryDateQuery();
    query.orderItems = this.checkedOrderItems;
    query.answerDeliveryDate = this.uddAnswerDeliveryDate;
    query.scheduledDeliveryDate = this.uddScheduledDeliveryDate;
    await this.$api.execute(query).then(res => {
      this.refreshListView();
    });
  }
  // 入荷処理ダイアログの表示
  public showCreatePurchaseDeliveryDialog(isTransitPost :boolean) {
    this.getCheckedOrderItems();
    let componentClass = Vue.extend(this.createPurchaseDelivery);
    var router = this.$router;
    let instance = new componentClass({
        router,
        propsData: {
          checkedOrderItems: this.checkedOrderItems,
          parentMainList: this.$refs.mainList,
          parent: this,
          isTransitPost: isTransitPost,
          isItemFlag: true,
        },
      });
    instance.$mount();
    instance.$on('hidden', () => {
      //destroyできない
      instance.$el.parentElement.removeChild(instance.$el);
      instance.$destroy();
    });
    this.$el.appendChild(instance.$el);
  }
  
  // 受注明細一覧へ遷移する
  public showSalesOrderItem(itemNo: string){
    if(itemNo) this.$router.push(String.format('/sales/SalesOrderItem?orderItemNo={0}',itemNo));
  }

  // 発注一覧へ遷移する
  public showPurchaseOrder() {
    const obj = (this.$refs.mainList as Components.ListView).selected as Common.PurchaseOrderItem;
    this.$router.push(String.format('/purchase/PurchaseOrder?orderNo={0}',obj.order.orderNo));
  }
  //関連伝票ダイアログを表示
  public showDirectAccessDialg(item:Common.PurchaseOrderItem){
    this.$api.launchDialog(Components.DirectAccessDialog, this.$router,{source : Common.DirectAccessTargetFlags.PurchaseOrder, sourceNo : item.orderNo, isItem: true},this.$el);
  }
  // 入荷明細表示ボタンの非活性制御
  public disabledShowPurchaseDeliveryItemButton(item: Common.OrderItem):boolean{
    return item.state != Common.OrderItemStatus.PurchaseOrderDelivering && item.state != Common.OrderItemStatus.PurchaseOrderCompleted;
  }

  // 入荷明細一覧へ遷移する
  public showPurchaseDeliveryItem(){
    const obj = (this.$refs.mainList as Components.ListView).selected as Common.PurchaseOrderItem;
    if(obj) {
      let routeData = this.$router.resolve(String.format('/purchase/PurchaseDeliveryItem?orderItemNo={0}', obj.orderItemNo));
      window.open(routeData.href, '_blank');
    }
  }

  //検索予備項目
  public isSearchVisible(usedType: Common.UsedTypes){
      return usedType == Common.UsedTypes.CommodityAttribute || usedType == Common.UsedTypes.OrderMemo || usedType == Common.UsedTypes.CommodityMemo ;
  }    
  public get searchTabs() : string[]{
    return this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText1) || 
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText2) || 
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText3) ||     
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText4) ||               
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText5) ||     
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveText6) ||                
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveMemo1) ||               
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveMemo2) ||     
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveMemo3) ||                         
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveDate1) ||               
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveDate2) ||     
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveDate3) ||            
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveList1) ||               
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveList2) ||     
              this.isSearchVisible(this.tenantSettings.usedTypeDetailReserveList3) 
              ? ['検索条件','予備項目']: ['検索条件'];
  }  
}
</script>

<style lang="scss">
.purchase_order_item{
  .cx_itembutton {
    font-size: 14px;
    height: 28px;
    padding: 2px 7px;
    outline: 0 !important;
    box-shadow: none;
    margin: -3px 10px 10px 0px;
    // min-width:120px;
  }
  .cx_link{
    .cx_textbox_read{
      font-weight: bolder;
      text-decoration: underline;
      cursor: pointer;
      &:hover {
        color: #3194ff !important; 
      }
    }
  }
}
</style>